import useRequest from './useRequest';

interface GetAssignerSupplierListOptions {
  skip?: boolean;
}

interface GetProvincesInfoResult {
  Provinces: { ProvinceName: string }[];
}

function useGetProvincesInfo(options?: GetAssignerSupplierListOptions) {
  const { skip = false } = options || {};
  const [_, result] = useRequest<GetProvincesInfoResult>('GetProvincesInfo', { skip });
  console.log(result);

  return result;
}

export default useGetProvincesInfo;
